export default __webpack_public_path__ + "static/media/svg-9.df0c8f81.svg";